import { render, staticRenderFns } from "./ModalMobile.vue?vue&type=template&id=b0d107b4&scoped=true"
import script from "./ModalMobile.vue?vue&type=script&lang=ts"
export * from "./ModalMobile.vue?vue&type=script&lang=ts"
import style0 from "./ModalMobile.vue?vue&type=style&index=0&id=b0d107b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0d107b4",
  null
  
)

export default component.exports